import React from "react";
import { useSelector } from "react-redux";
import { constants } from "@qgiv/core-js";
import { AutomatedEmployerMatching } from "@qgiv/core-donor";
import { useFormikContext } from "formik";
import { selectAllFormSettings } from "../../../redux/slices/formSettingsSlice";
import { selectAllP2pSettings } from "../../../redux/slices/p2pSettingsSlice";
import { selectCmsControlByIdByPage } from "../../../redux/slices/cmsSettingsSlice";
import { selectIsCms } from "../../../redux/slices/configSlice";

/**
 * @param {object} props
 * @param {number} props.controlId
 * @returns {React.JSX.Element|null}
 */
const ConnectedEmployerMatching = ({ controlId }) => {
    const {
        ENUMS: { DefaultView, GiftMatchingService },
    } = constants;
    const { values, setValues } = useFormikContext();
    const isCms = useSelector(selectIsCms);
    const formSettings = useSelector(selectAllFormSettings);
    const {
        enableMatching,
        path,
        thirdPartyMatching,
        providerLogoSrc = "/resources/core/images/logo-doubledonation.png",
        providerLabel = "Double The Donation",
    } = formSettings;
    const { enableOptionalDonation } = useSelector(selectAllP2pSettings);

    const { Donation_Amount, Employer } = values;

    const control = useSelector((state) =>
        selectCmsControlByIdByPage(
            controlId,
            DefaultView.REGISTRATION_CHECKOUT_STEP,
            state,
        ),
    );

    // default grey spinner color
    const spinnerColor = "#66737D";

    const isDtD =
        thirdPartyMatching === GiftMatchingService.DOUBLE_THE_DONATION;

    const { options } = control;

    const {
        sectionHeading = "Your gift could be worth more!",
        description = "Find out if you're eligible for a matching gift from your employer.",
        matchingEmployerLabel = "Employer",
        teaserLabel = "Your gift could be worth more with a matching gift from your employer!",
    } = options;

    const searchEnabled = !!(Employer && Employer.length > 1);

    const employerField = Employer;

    const displayMatchingGift = enableMatching && enableOptionalDonation;

    const donationTotal = values.Donation_Amount;

    const isVisible = !!Donation_Amount || isCms;
    const displayTeaser = !isVisible && displayMatchingGift;

    const matchingProps = {
        description,
        displayMatchingGift,
        displayTeaser,
        donationTotal,
        employerField,
        isDtD,
        isVisible,
        matchingEmployerLabel,
        path,
        providerLabel,
        providerLogoSrc,
        searchEnabled,
        sectionHeading,
        setValues,
        spinnerColor,
        teaserLabel,
        values,
    };

    return displayMatchingGift ? (
        <AutomatedEmployerMatching {...matchingProps} />
    ) : null;
};

export default ConnectedEmployerMatching;
